import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { FUNDING_STEP_ACTION } from '../../Funding.actions';
import { FundingStepActionButton } from '../fundingStepActionButton/FundingStepActionButton';
import { TFundingRequirementsSteps } from '../orderFundingRequirements';
import StepItem from '../stepItem/StepItem';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    handleFundingStepAction: () => {
        dispatch({ type: FUNDING_STEP_ACTION, step: 'ONFIDO_VERIFICATION' });
    }
});

const IdCheckVerificationAction = ({
    status,
    handleFundingStepAction
}: {
    status: TFundingRequirementsSteps['0']['status'];
} & ReturnType<typeof mapDispatchToProps>) => {
    return (
        <StepItem
            title={
                <FormattedMessage
                    id="_.funding_requirements.id_check_verification.titleSingular"
                    defaultMessage="Complete an identity check"
                />
            }
            caption={
                <FormattedMessage
                    id="_.funding_requirements.id_check_verification.captionSingular"
                    defaultMessage="Send yourself a SMS to do this."
                />
            }
            action={
                <FundingStepActionButton
                    actionMessage={
                        <FormattedMessage
                            id="_.funding_requirements.onfido_action"
                            defaultMessage="Send SMS"
                        />
                    }
                    pendingMessage={
                        <FormattedMessage
                            id="_.funding_requirements.onfido_action_pending"
                            defaultMessage="Pending"
                        />
                    }
                    status={status}
                    handleFundingStepAction={handleFundingStepAction}
                    stepName="ID check"
                />
            }
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(IdCheckVerificationAction);
